import React, { ReactNode, useContext, useEffect, useState } from "react"
import { breakPointsTheme } from "./theme"
import { Outlet } from "react-router-dom"
type MediaQueryType = Record<"isSmall" | "isMedium" | "isLarge" | "isExtraLarge", boolean>

export const MediaQueryContext = React.createContext<MediaQueryType>({ "isSmall": false, "isMedium": false, "isLarge": false, "isExtraLarge": false })

export const MediaQueryProvider = () => {
    const [matches, setMatches] = useState<MediaQueryType>({
        isSmall: false,
        isMedium: false,
        isLarge: false,
        isExtraLarge: false
    })
    useEffect(() => {
        const smallQuery = window.matchMedia(breakPointsTheme.breakpoints.down("sm").substring(7))
        const mediumQuery = window.matchMedia(breakPointsTheme.breakpoints.down("md").substring(7))
        const largeQuery = window.matchMedia(breakPointsTheme.breakpoints.down("lg").substring(7))
        const extraLargeQuery = window.matchMedia(breakPointsTheme.breakpoints.down("xxl").substring(7))

        const updateMediaQuery = () => {
            setMatches({
                isSmall: smallQuery.matches,
                isMedium: mediumQuery.matches,
                isLarge: largeQuery.matches,
                isExtraLarge: extraLargeQuery.matches,
            })
        }
        updateMediaQuery()
        smallQuery.addEventListener("change", updateMediaQuery)
        mediumQuery.addEventListener("change", updateMediaQuery)
        largeQuery.addEventListener("change", updateMediaQuery)
        extraLargeQuery.addEventListener("change", updateMediaQuery)

        return () => {
            smallQuery.removeEventListener("change", updateMediaQuery)
            mediumQuery.removeEventListener("change", updateMediaQuery)
            largeQuery.removeEventListener("change", updateMediaQuery)
            extraLargeQuery.removeEventListener("change", updateMediaQuery)
        }
    }, [])
    return (
        <MediaQueryContext.Provider value={matches}>
            <Outlet />
        </MediaQueryContext.Provider>
    )

}
export { }